import type { RecognizedAppMatch } from '../enums/recognized-app-match.enum.js'

/**
 * Whether a URL points at the computer it's opened on (localhost, 127.x, ::1).
 * An AI app signing in through such an address can't be told apart from any
 * other program on that computer, so it's never recognized.
 */
export function isLoopbackUrl(url: URL): boolean {
  const host = url.hostname.replace(/^\[|\]$/g, '').toLowerCase()
  return host === 'localhost' || host.endsWith('.localhost') || host === '::1' || /^127\./.test(host)
}

/** Why a recognized-app value isn't acceptable, or null when it is. */
export function validateRecognizedAppValue(match: RecognizedAppMatch, value: string): string | null {
  let url: URL
  try {
    url = new URL(value)
  } catch {
    return 'Enter a full URL.'
  }
  if (isLoopbackUrl(url)) return "Addresses on this computer (localhost, 127.0.0.1, ::1) can't be recognized."
  if (match === 'client_id_url' && url.protocol !== 'https:') return 'A client ID URL must use https.'
  if (url.protocol === 'http:') return 'Use https.'
  if (url.hash) return "Remove the '#…' part."
  return null
}
